import { get, postFormData} from "./Request";

const corePath = "File/";

export async function Add(data, token) {
    return await postFormData(`${corePath}Add`, data, token);
}

